module.exports = __webpack_public_path__ + "static/media/red pleated top and long skirt.3682a62b.jpg";